import React from "react";
import { isArray } from "lodash";
import { _getTranslation } from "../utils/helper";

const CardReferenceDoc = ({ data, ...props }) => {
  return (
    <div className="group border border-ideaListGrey100 rounded-md bg-white p-4 sm:p-8">
      <div class="font-bold text-ideaBlue100 mb-3">{data.title}</div>

      {data.date && (
        <div class="text-mobileS md:text-desktopS font-bold mb-3">
          {data.date}
        </div>
      )}
      {data.text && (
        <div
          class="text-mobileS md:text-desktopS"
          dangerouslySetInnerHTML={{
            __html: data.text,
          }}
        ></div>
      )}

      {isArray(data.download) && data.download.length > 0 && (
        <ul class="tema-list tm--blue tm--hover---underline">
          {data.download.map((item, i) => (
            <li>
              <a href={item} target="_blank">
                {_getTranslation("download_document")}
                {data.download.length > 1 ? ` ${i + 1}` : ""}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CardReferenceDoc;
